import { DOCTYPES } from '@/constants/doctypes'
import { HAS_LIST_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeDatevSettingsHome, root: routeDatevSettingsRoot } = createSingleViewRoutes({
  doctypes: {
    [DOCTYPES.DATEV_UNTERNEHMEN_ONLINE_SETTINGS]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
  },
  name: 'datev-settings-home',
  path: 'datev',
  view: async () =>
    await import('@/components/viewsExternal/settings/interfaces/ViewInterfaces.vue'),
})

export { routeDatevSettingsHome, routeDatevSettingsRoot }
